goog.require('el8.template.stats.reports');

var el8 = el8 || {};
if(!el8.main) { el8.main = {}; }
el8.main.statsReports = {};


el8.main.statsReports.practiceUsageReport = function(report_type, interval, forWhen, successCallback) {
    
    var url = null;
    if (report_type === 'all') {
        url = "/stats/reports/usage/practices/" + interval + "/" + forWhen + '/';
    }
    else {
        url = "/stats/reports/usage/practices/" + report_type + "/" + interval + "/" + forWhen + '/';
    }
    
    $.ajax({
      url: url,
      success: function(data){
          $('#load-alert').fadeOut();
          if (report_type === 'all') {
              $("#report_data").html(el8.template.stats.reports.practiceUsage({data: data}));
          }
          else {
              $("#report_data").html(el8.template.stats.reports.userUsage({data: data}));
          }
          
          successCallback(data);
      }
    });
};

el8.main.statsReports.systemHealthReport = function(from_formatted, to_formatted) {
    var url = "/stats/reports/system-health/" + from_formatted + "-" + to_formatted + '/';
    
    $.ajax({
      url: url,
      success: function(data){
          $('#load-alert').fadeOut();
          $("#report_data").html(el8.template.stats.reports.systemHealth({data: data}));
      }
    });
};

